export const ENV_VARS_WRAPPER = 'nexyConfig';
